import { ParseKeys } from 'i18next'
import { LocaleEnum } from './enums'

export const USER_LOCALE_STORAGE_KEY = 'user_locale'

export type Option = { id: string; label: string }
export type OptionEnum<T> = { id: T; label: string | ParseKeys }

export const localeEnumLabels: Record<LocaleEnum, ParseKeys> = {
  [LocaleEnum.ru]: 'locale.russian',
  [LocaleEnum.en]: 'locale.english',
  // [LocaleEnum.fr]: 'locale.french',
}

export const localeEnumOptions: OptionEnum<LocaleEnum>[] = Object.keys(
  LocaleEnum,
).map((value) => {
  const label = localeEnumLabels[value as keyof typeof LocaleEnum]
  return {
    label,
    id: value as LocaleEnum,
  }
})
